import { html } from "lit";
var icon_history_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 27">
    <path
      d="M16.875.688C24.124.688 30 6.564 30 13.812c0 7.145-5.71 12.957-12.815 13.122l-.31.003v-1.875c6.213 0 11.25-5.037 11.25-11.25 0-6.212-5.037-11.25-11.25-11.25-6.116 0-11.093 4.882-11.247 10.96l-.003.291v.937H3.749v-.937C3.75 6.564 9.627.687 16.875.687z" />
    <path
      d="M7.775 10.333l1.326 1.326-4.413 4.413-4.413-4.413 1.326-1.326 3.087 3.088 3.087-3.088zm9.1-4.024v7.499H22.5v1.876H15V6.309h1.875z" />
  </svg>
`;
export {
  icon_history_default as default
};
//# sourceMappingURL=icon-history.js.map
